import { gql } from '@apollo/client';
import { GqlOrganization, GqlOrganizationFragment } from '../../../core/gql/fragments/organization';

export interface Input {
  id: number;
  businessType: string;
  country: string;
  name: string;
  notes: string;
  numberOfTeamsPaidFor: number;
  paymentProvider: string;
  plan: string;
  resendInvite: boolean;
  sport: string;
  timezone: string;
  zipCode: string;
  updateAllSeasonsAddress: boolean;
}

export interface Data {
  updateOrganization: GqlOrganization;
}

export const MUTATION = gql`
  mutation UpdateOrganization(
    $id: Int!
    $country: String
    $name: String!
    $sport: String
    $timezone: String
    $zipCode: String
    $mailingAddress: String
    $mailingAddress2: String
    $mailingCity: String
    $mailingState: String
    $mailingZip: String
    $mailingCountry: String
    $updateAllSeasonsAddress: Boolean
  ) {
    updateOrganization(
      country: $country
      id: $id
      name: $name
      sport: $sport
      timezone: $timezone
      zipCode: $zipCode
      mailingAddress: $mailingAddress
      mailingAddress2: $mailingAddress2
      mailingCity: $mailingCity
      mailingState: $mailingState
      mailingZip: $mailingZip
      mailingCountry: $mailingCountry
      updateAllSeasonsAddress: $updateAllSeasonsAddress
    ) {
      ...OrganizationFields
    }
  }
  ${GqlOrganizationFragment}
`;
